import DOMPurify from 'dompurify';

const ALLOWED_IFRAME_HOSTS = [
  'www.youtube.com',
  'youtube.com',
  'youtu.be',
  'www.youtube-nocookie.com',
  'player.vimeo.com',
];

const isAllowedEmbedSrc = (src: string): boolean => {
  try {
    const { protocol, hostname } = new URL(src);
    return protocol === 'https:' && ALLOWED_IFRAME_HOSTS.includes(hostname);
  } catch {
    return false;
  }
};

DOMPurify.addHook('uponSanitizeElement', (node, data) => {
  if (data.tagName !== 'iframe') {
    return;
  }
  const element = node as Element;
  if (!isAllowedEmbedSrc(element.getAttribute('src') ?? '')) {
    element.remove();
  }
});

/**
 * Sanitize rich-text HTML for rendering, preserving Tiptap video embeds.
 *
 * Default DOMPurify strips all <iframe> tags, which silently removed
 * YouTube/Vimeo videos from saved rich-text content. This allows iframes but
 * restricts their src to known video hosts so the XSS surface stays closed.
 */
export const sanitizeRichTextHtml = (html: string): string =>
  DOMPurify.sanitize(html, {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: [
      'allow',
      'allowfullscreen',
      'frameborder',
      'scrolling',
      'src',
      'width',
      'height',
    ],
  });
